export enum SupportConfig {
  PHONE_NUMBER = '1300049532',
  PHONE_NUMBER_DISPLAY = '1300 049 532',
  EMAIL_ADDRESS = 'help@spaceship.com.au',
}
